module.exports = __webpack_public_path__ + "img/icon-reserve.64bc82fc.svg";